
import { feedbackModel } from "./feedbackmodel";
import { physician_education } from "./physician_education";
import { physician_experience } from "./physician_experience";
import { physician_specialities } from "./physician_specialities";
import { RatingModel } from "./ratingModel";
import { Transactions } from "./transactions_model";

export class Physician {
  physicians_consultfee: any;
  user_id: number;
  oid: number;
  phy_id: number;
  first_name: string;
  last_name: string;
  dob: string;
  add_1: string;
  add_2: string;
  city: string;
  state: string;
  zip: number;
  contact_n: number;
  email: string;
  email_id: string;
  degree: string;
  yearq: number;
  expertise: string;
  institution: string;
  designation: string;
  employer: string;
  grad_year: number;
  orgc: string;
  oname: string;
  u_id: number;
  ppurl: string;
  s_url: string;
  physician_education: physician_education[];
  physician_speciality: physician_specialities[];
  physician_experience: physician_experience[];
  consult_fee: any;
  status: boolean;
  feedbacks: feedbackModel[];
  ratings: RatingModel;
  transactions: Transactions;
  paid_account: boolean;
  qualification: string;
  r_no: string;
  smc: string;
  physician_qualification: any;
  physician_consultfee: any;
  consultation_share: string;
  title: string;
  ac_status: boolean;
  verified: boolean;
  consult_now: boolean[];
  location: string
  days: any;
  org_code: any;
  physician_dashboard: Physician;
  name: string;
  avatarimg: string;
  aptinterval: number;
}
